import {
  GraphQLList,
  GraphQLNonNull,
  GraphQLObjectType,
  GraphQLString
} from 'graphql'
import { Context } from '../shared'
import { normalizeApplication } from './helpers/application'
import {
  architectureComponentApplicationsArgs,
  ArchitectureComponentApplicationsArgs,
  ArchitectureAssociatedApplicationsFilterArg
} from '../types/architecture-component-applications-args'
import { Application, ApplicationType } from '../types/application'
import { ContrastGraphQLFieldConfig } from '../index'

interface ArchitectureAssociatedApplication {
  readonly application: Partial<Application>
  readonly componentsHashes: string[]
}

const architectureAssociatedApplication = new GraphQLObjectType({
  name: 'ArchitectureAssociatedApplication',
  fields: () => ({
    application: {
      description: 'Application details',
      type: new GraphQLNonNull(ApplicationType)
    },
    componentsHashes: {
      description: 'A list of the application architecture component hashes',
      type: new GraphQLNonNull(new GraphQLList(GraphQLString))
    }
  })
})

export function mapArchitectureAssociatedAppsFilters(
  filters: ArchitectureAssociatedApplicationsFilterArg
) {
  const {
    componentHashes = [],
    technologies = [],
    languages = [],
    tags = [],
    servers = [],
    environments = [],
    customMetadata
  } = filters

  return {
    componentHashes,
    filterTechs: technologies,
    filterLanguages: languages,
    filterTags: tags,
    filterServers: servers,
    filterEnvironments: environments,
    metadataFilters: customMetadata
  }
}

export const architectureAssociatedApplications: ContrastGraphQLFieldConfig<
  any,
  Context,
  ArchitectureComponentApplicationsArgs,
  ArchitectureAssociatedApplication[]
> = {
  description:
    'Get associated applications based on the primary application architecture components',
  type: new GraphQLNonNull(new GraphQLList(architectureAssociatedApplication)),
  args: architectureComponentApplicationsArgs,
  async resolve(_source, args, context) {
    const { organizationID, applicationID, filters } = args

    const mappedFilters = filters
      ? mapArchitectureAssociatedAppsFilters(filters)
      : {}

    const { applications = [] } = await context.connector.post(
      `/${organizationID}/flowmap/${applicationID}/applications`,
      mappedFilters
    )

    return applications.map(({ application, componentsHashes = [] }) => {
      return {
        application: normalizeApplication(application),
        componentsHashes
      }
    })
  }
}
